import * as React from "react";
import { styled, Tabs, TabsProps } from "@mui/material";

const PanelTabs: React.FC<TabsProps> = (props) => {
  return <StyledTabs {...props} />;
};

export default PanelTabs;

const StyledTabs = styled(Tabs)(({ theme }) => ({
  position: "sticky",
  top: "48px",
  marginLeft: theme.spacing(-3),
  marginRight: theme.spacing(-2),
  background: theme.palette.background.default,
  zIndex: 2,
}));
